import {
    useCallback, ReactNode,
} from 'react'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { SerializedStyles } from '@emotion/react'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'

import styles from './DashboardCardItem.style'

type Props = {
    titleKey: string,
    infoKey?: string,
    iconSrc: string,
    linkTo?: string,
    disabled?: boolean,
    children?: ReactNode,
    customClasses?: {
        info?: SerializedStyles,
    },
}

const DashboardCardItem = ({
    titleKey,
    infoKey,
    iconSrc,
    linkTo,
    disabled = false,
    children,
    customClasses = {},
}: Readonly<Props>) => {
    const classesProps = {
        active: !!linkTo,
        disabled,
    }
    const navigate = useNavigate()
    const { t } = useTranslation()
    const classes = useStyle(styles)

    const navigateToLink = useCallback(() => {
        if (linkTo) {
            navigate(linkTo)
        }
    }, [
        linkTo,
        navigate,
    ])

    return (
        <div
            data-testid="dashboard-card"
            css={classes.container(classesProps)}
            onClick={navigateToLink}
            aria-hidden="true"
        >
            <div css={classes.topWrapper(classesProps)}>
                <img
                    css={classes.icon}
                    src={iconSrc}
                    alt={titleKey}
                />
            </div>
            <div css={classes.bottomWrapper(classesProps)}>
                <Typography
                    variant="h3"
                >
                    {t(titleKey)}
                </Typography>
                {(infoKey && (
                    <div css={customClasses.info}>
                        <Typography
                            variant="h5"
                        >
                            {t(infoKey)}
                        </Typography>
                        {children}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default DashboardCardItem
